module.exports = __webpack_public_path__ + "assets/img/ico-6.856e640b.webp";